//Common
import { fn_isValidNumber } from "@/common/utils/util";

//Util
import { MENSAGENS_ERRO, showMensagemErro } from "./mensagens";

/*
 * Coloca o foco no próximo campo de input habilitado em um grid
 */
export function fn_setFocusNextField(formRef, nameField, items, index) {
  let nextIndex = index + 1;

  //Encontra o próximo campo habilitado
  while (
    nextIndex < items.length &&
    !fn_isCampoHabilitado(formRef, nameField, items, nextIndex)
  ) {
    nextIndex++;
  }

  //Passa o foco para o próximo campo habilitado
  if (nextIndex < items.length) {
    const itemNext = items[nextIndex];

    const key =
      itemNext.id || itemNext.value || itemNext.codigo || itemNext.sigla;

    const itemNextRef = formRef.current.getFieldRef(`${nameField}[${key}]`);

    itemNextRef.current?.focus();
    itemNextRef.current?.select();
  } else {
    //Se for o último campo habilitado, volta o foco para o primeiro campo
    const item1 = items.find((item, idx) =>
      fn_isCampoHabilitado(formRef, nameField, items, idx),
    );

    const key = item1.id || item1.value || item1.codigo || item1.sigla;

    if (item1) {
      const item1Ref = formRef.current.getFieldRef(`${nameField}[${key}]`);
      item1Ref.current?.focus();
      item1Ref.current?.select();
    }
  }
}

/*
 * Coloca o foco no campo anterior de input habilitado em um grid
 */
export function fn_setFocusPrevField(formRef, nameField, items, index) {
  let prevIndex = index - 1;

  //Encontra o campo anterior habilitado
  while (
    prevIndex >= 0 &&
    !fn_isCampoHabilitado(formRef, nameField, items, prevIndex)
  ) {
    prevIndex--;
  }

  //Passa o foco para o campo anterior habilitado
  if (prevIndex >= 0) {
    const itemPrev = items[prevIndex];
    const key =
      itemPrev.id || itemPrev.value || itemPrev.codigo || itemPrev.sigla;

    const itemPrevRef = formRef.current.getFieldRef(`${nameField}[${key}]`);

    itemPrevRef.current?.focus();
    itemPrevRef.current?.select();
  }
}

/*
 * Coloca o foco no próximo campo de input habilitado em um grid (matriz) com nome composto por dois campos (ref. linha e coluna)
 */
export function fn_setFocusNextFieldComposto(
  formRef,
  nameField,
  items,
  index,
  complementoIndice,
) {
  let nextIndex = index + 1;

  //Encontra o próximo campo habilitado
  while (
    nextIndex < items.length &&
    !fn_isCampoHabilitado(
      formRef,
      nameField,
      items,
      nextIndex,
      complementoIndice,
    )
  ) {
    nextIndex++;
  }

  //Passa o foco para o próximo campo habilitado
  if (nextIndex < items.length) {
    const itemNext = items[nextIndex];
    const itemNextRef = formRef.current.getFieldRef(
      `${nameField}[${itemNext.id}-${complementoIndice}]`,
    );

    itemNextRef.current?.focus();
    itemNextRef.current?.select();
  } else {
    //Se for o último campo habilitado, volta o foco para o primeiro campo
    const item1 = items.find((item, idx) =>
      fn_isCampoHabilitado(formRef, nameField, items, idx, complementoIndice),
    );
    if (item1) {
      const item1Ref = formRef.current.getFieldRef(
        `${nameField}[${item1.id}-${complementoIndice}]`,
      );
      item1Ref.current?.focus();
      item1Ref.current?.select();
    }
  }
}

/*
 * Coloca o foco no campo anterior de input habilitado em um grid (matriz) com nome composto por dois campos (ref. linha e coluna)
 */
export function fn_setFocusPrevFieldComposto(
  formRef,
  nameField,
  items,
  index,
  complementoIndice,
) {
  let prevIndex = index - 1;

  //Encontra o campo anterior habilitado
  while (
    prevIndex >= 0 &&
    !fn_isCampoHabilitado(
      formRef,
      nameField,
      items,
      prevIndex,
      complementoIndice,
    )
  ) {
    prevIndex--;
  }

  //Passa o foco para o campo anterior habilitado
  if (prevIndex >= 0) {
    const itemPrev = items[prevIndex];
    const itemPrevRef = formRef.current.getFieldRef(
      `${nameField}[${itemPrev.id}-${complementoIndice}]`,
    );

    itemPrevRef.current?.focus();
    itemPrevRef.current?.select();
  }
}

/*
 * Verifica se o campo está habilitado
 */
function fn_isCampoHabilitado(
  formRef,
  nameField,
  items,
  index,
  complementoIndice,
) {
  const item = items[index];

  let itemRef = null;
  if (complementoIndice) {
    itemRef = formRef.current.getFieldRef(
      `${nameField}[${item.id}-${complementoIndice}]`,
    );
  } else {
    itemRef = formRef.current.getFieldRef(`${nameField}[${item.id}]`);
  }
  return !itemRef.current?.disabled;
}

// /*
//  * Desabilita todos os campos da tela, porém esse método não funciona para campo react-select
//  */
// export function fn_desabilitarCamposFormID(
//   idForm,
//   desabilitar,
//   camposExcecao = [],
// ) {
//   const form = document.getElementById(idForm);

//   if (form) {
//     const elements = form.elements;

//     for (let i = 0; i < elements.length; i++) {
//       if (elements[i]?.name && camposExcecao.includes(elements[i].name)) {
//         elements[i].disabled = !desabilitar;
//       } else {
//         elements[i].disabled = desabilitar;
//       }
//     }
//   }
// }

/*
 * Coloca o foco no primeiro campo habilitado dentro de um elemento da tela (Ex: o conteúdo de uma aba)
 * @domRef: ref do elemento (div) que envolve os campos
 * OBS: Em aba, chamar quando a aba passa a ser a ativa: enquanto a aba está escondida o campo não recebe o foco.
 */
export function fn_setFocusPrimeiroCampoHabilitado(domRef) {
  const campos = Array.from(
    domRef?.current?.querySelectorAll("input, select, textarea") || [],
  );

  const primeiroCampo = campos.find(
    (campo) =>
      !campo.matches(":disabled") && //considera também o campo dentro de fieldset desabilitado
      campo.type != "hidden" &&
      campo.tabIndex != -1,
  );

  primeiroCampo?.focus();
}

/*
 * Evento de keyDown para colocar no form para não submeter o formulário com a tecla "enter",
 * exceto em determinados campos e botões
 */
export function fn_handleKeyDownEnterForm(event, listCamposExcecao) {
  if (
    event.key === "Enter" &&
    event.target.type !== "submit" &&
    event.target.type !== "textarea" &&
    event.target.name !== "btnSalvar" &&
    event.target.name !== "btnConfirmar" &&
    event.target.name !== "btnConsultar" &&
    event.target.name !== "btnAdicionar" &&
    event.target.name !== "btnFechar" &&
    event.target.id !== "lastField" &&
    !listCamposExcecao?.includes(event.target.name)
  ) {
    event.preventDefault();
  }
}

/*
 * Retorna a primeira opção de um campo Select.
 */
export function fn_getPrimeiraOpcaoSelect(opcoes) {
  return opcoes && opcoes.length > 0
    ? opcoes[0]?.options
      ? opcoes[0].options[0]
      : opcoes[0]
    : null;
}

/*
 * Permite digitar apenas valores válidos para um campo de valor percentual.
 * Se digitar o caracter "." (ponto) ele é substituído pelo caracter "," (vírgula).
 */
export function fn_validaKeyCampoPercentual(value) {
  //Remove todos os caracteres que não são dígitos, vírgula ou ponto
  value = value.replace(/[^\d,.]/g, "");

  //Substitui ponto por vírgula
  value = value.replace(".", ",");

  //Se houver mais de uma vírgula, remove os caracteres após a primeira vírgula
  const commaIndex = value.indexOf(",");
  if (commaIndex !== -1) {
    value =
      value.slice(0, commaIndex + 1) +
      value.slice(commaIndex + 1).replace(",", "");
  }
  return value;
}

/*
 * Permite digitar apenas valores válidos para um campo de valor monetário.
 * Se digitar o caracter "." (ponto) ele é substituído pelo caracter "," (vírgula).
 * Permite apenas duas casas decimais.
 */
export function fn_validaKeyCampoCurrency(value) {
  //Remove todos os caracteres que não são dígitos, vírgula ou ponto
  value = value.replace(/[^\d,.]/g, "");

  //Substitui ponto por vírgula
  value = value.replace(".", ",");

  //Se houver mais de uma vírgula, remove os caracteres após a primeira vírgula
  const commaIndex = value.indexOf(",");
  if (commaIndex !== -1) {
    value =
      value.slice(0, commaIndex + 1) +
      value.slice(commaIndex + 1).replace(",", "");
  }

  //Limita o número a ter no máximo duas casas decimais
  const parts = value.split(",");
  if (parts.length > 1) {
    parts[1] = parts[1].slice(0, 2);
    value = parts.join(",");
  }
  return value;
}

/*
 * Permite digitar apenas valores números.
 */
export function fn_validaKeyCampoNumerico(value) {
  //Remove todos os caracteres que não são dígitos
  value = value.replace(/[^\d]/g, "");

  return value;
}

/*
 * Verifica se o valor informado está dentro do valor mínimo e máximo estabelecido
 */
export function fn_validarRangeNumerico(valorInput, valorMin, valorMax) {
  if (
    !fn_isValidNumber(valorInput) ||
    !fn_isValidNumber(valorMin) ||
    !fn_isValidNumber(valorMax)
  ) {
    showMensagemErro(MENSAGENS_ERRO.VALOR_NUMERICO);
    return false;
  } else {
    //Valida valor mínimo
    if (Number(valorInput) < Number(valorMin)) {
      showMensagemErro(MENSAGENS_ERRO.VALOR_MINIMO_PERMITIDO, valorMin);
      return false;
    }
    //Valida valor máximo
    else if (Number(valorInput) > Number(valorMax)) {
      showMensagemErro(MENSAGENS_ERRO.VALOR_MAXIMO_PERMITIDO, valorMax);
      return false;
    }
  }

  return true;
}

/*
 * Retorna o nome das abas que possuem algum dos campos com erro, para a tela que tem mais de uma aba no mesmo formulário
 * marcar as abas com erro (borda vermelha). O campo é localizado pelo name dentro do conteúdo de cada aba.
 * @errors: Erros do formulário { nomeCampo: mensagem } (ex: fn_getCamposObrigatoriosNaoInformados)
 * @abas: { nomeAba: ref do elemento com o conteúdo da aba }
 */
export function fn_getAbasCamposComErro(errors, abas) {
  const nomesCamposErro = Object.keys(errors || {});

  return Object.entries(abas)
    .filter(([, ref]) => {
      const nomesCamposAba = [
        ...(ref.current?.querySelectorAll("[name]") || []),
      ].map((elemento) => elemento.getAttribute("name"));

      return nomesCamposErro.some((nome) => nomesCamposAba.includes(nome));
    })
    .map(([nomeAba]) => nomeAba);
}

/*
 * Função que será chamada nas telas para validar os campos obrigatórios
 * @formRef: Referência do formulário
 * @data: Dados do formulario {key: valor}
 * @arrayNomesCampoExcecao: Array com os nomes dos campos (key) ref. parâmetro data, que não serão validados
 */
export function fn_validarCamposObrigatorios(
  formRef,
  data,
  arrayNomesCampoExcecao,
  showMessageErro = true,
) {
  formRef.current.setErrors([]);

  const { errors, hasError } = validator(data, arrayNomesCampoExcecao);

  if (hasError) {
    formRef.current.setErrors(errors);

    if (showMessageErro) {
      showMensagemErro(MENSAGENS_ERRO.CAMPOS_OBRIGATORIOS);
    }
    return false;
  } else {
    return true;
  }
}

/*
 * Retorna os campos obrigatórios não informados { nomeCampo: mensagem }, com a mesma regra do fn_validarCamposObrigatorios.
 * Serve para a tela saber quais campos estão com erro logo depois da validação (o getErrors do formulário só é
 * atualizado na próxima renderização)
 * @data: Dados do formulario {key: valor}
 * @arrayNomesCampoExcecao: Array com os nomes dos campos (key) ref. parâmetro data, que não serão validados
 */
export function fn_getCamposObrigatoriosNaoInformados(
  data,
  arrayNomesCampoExcecao,
) {
  return validator(data, arrayNomesCampoExcecao).errors;
}

/*
 * Valida os campos obrigatórios
 * @data: Dados do formulario {key: valor}
 * @filter: Array com os nomes dos campos (key) ref. parâmetro data, que não serão validados
 */

function validator(data, arrayNomesCampoExcecao = [], parentPath = "") {
  let errors = {};
  let hasError = false;

  Object.entries(data || {}).forEach(([key, value]) => {
    const fieldPath = parentPath ? `${parentPath}.${key}` : key;

    // Ignora campos de exceção
    if (
      arrayNomesCampoExcecao.includes(key) ||
      arrayNomesCampoExcecao.includes(fieldPath)
    ) {
      return;
    }

    // Array
    if (Array.isArray(value)) {
      if (value.length === 0) {
        errors[fieldPath] = "Campo obrigatório";
        hasError = true;
        return;
      }

      value.forEach((item, index) => {
        if (item && typeof item === "object") {
          const result = validator(
            item,
            arrayNomesCampoExcecao,
            `${fieldPath}[${index}]`,
          );

          if (result.hasError) {
            errors = { ...errors, ...result.errors };
            hasError = true;
          }
        } else if (item === "" || item === null || item === undefined) {
          errors[`${fieldPath}[${index}]`] = "Campo obrigatório";
          hasError = true;
        }
      });

      return;
    }

    // Objeto
    if (typeof value === "object" && value !== null) {
      const result = validator(value, arrayNomesCampoExcecao, fieldPath);

      if (result.hasError) {
        errors = { ...errors, ...result.errors };
        hasError = true;
      }

      return;
    }

    // Campo simples
    if (value === "" || value === null || value === undefined) {
      errors[fieldPath] = "Campo obrigatório";
      hasError = true;
    }
  });

  return { errors, hasError };
}

/*
 * Ordena o resultado pela coluna acionada
 */
export function fn_ordenarColunaTabela(items, campoOrder, direcaoOrder) {
  const itemsOrd = [...items].sort((a, b) => {
    if (!campoOrder) return 0;

    let aValue = a;
    let bValue = b;

    if (campoOrder.includes(".")) {
      const keys = campoOrder.split(".");
      aValue = keys.reduce((obj, key) => obj?.[key], a);
      bValue = keys.reduce((obj, key) => obj?.[key], b);
    } else {
      aValue = a[campoOrder];
      bValue = b[campoOrder];
    }

    // Se os valores forem numéricos, converte para Number
    if (fn_isValidNumber(aValue) && fn_isValidNumber(bValue)) {
      aValue = Number(aValue);
      bValue = Number(bValue);
    }

    const direction = direcaoOrder === "ASC" ? 1 : -1;

    if (typeof aValue === "string" && typeof bValue === "string") {
      return direction * aValue.localeCompare(bValue);
    }

    return aValue > bValue ? direction : aValue < bValue ? -direction : 0;
  });

  return itemsOrd;
}

/*
 * Retorna as opções do select com checkbox e selecionadas conforme a ação de uma opção de todos
 */
export function fn_getOpcoesSelectCheck(opcoes, campoFiltro, selectedOptions) {
  return opcoes.map((opt) => {
    if (!opt.isAction) return opt;

    const opcoesFiltro = opcoes.filter(
      (o) => !o.isAction && o[campoFiltro] === opt[campoFiltro],
    );

    const todosSelecionados =
      opcoesFiltro.length > 0 &&
      opcoesFiltro.every((c) =>
        selectedOptions.some((s) => s.value === c.value),
      );

    return {
      ...opt,
      isChecked: todosSelecionados,
    };
  });
}

/*
 * Agrupa as opções do select (USelect com showGrupoCheck), no formato de grupos do react-select:
 * [opção sem grupo, ..., { label: "GRUPO", options: [...] }, ...]
 * @getGrupo: função que retorna o nome do grupo da opção (sem grupo: null). As opções não são alteradas.
 * As opções sem grupo (ex: opções "Todos") ficam no início, na ordem em que vieram.
 * Os grupos ficam na ordem em que aparecem pela primeira vez; a opção de um grupo que já apareceu entra nele.
 */
export function fn_agruparOpcoesSelect(opcoes, getGrupo) {
  const semGrupo = [];
  const grupos = [];

  for (const opcao of opcoes || []) {
    const nomeGrupo = getGrupo ? getGrupo(opcao) : null;

    if (!nomeGrupo) {
      semGrupo.push(opcao);
      continue;
    }

    let grupo = grupos.find((item) => item.label == nomeGrupo);
    if (!grupo) {
      grupo = { label: nomeGrupo, options: [] };
      grupos.push(grupo);
    }
    grupo.options.push(opcao);
  }

  return [...semGrupo, ...grupos];
}
